var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObserverGradientShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 193.159 286.962",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M1.63357 285.655L0 286.962H177.292V275.798L184.159 252.298L188.659 218.798L193.159 177.298L190.688 157.803L188.659 144.798L184.659 131.798L172.159 121.298L140.7 106.182L139.72 103.242L132.859 100.955L127.305 91.4802L126.651 89.5199L129.592 85.5993L131.225 83.9657L129.592 80.3718L127.958 77.7581L128.938 76.778L129.592 69.5903L128.938 65.9964L131.225 65.343L132.206 63.7094L133.839 60.769L132.206 54.5614L134.493 53.2545L135.799 49.9874L134.493 49.0072L131.225 47.0469V44.1065V41.1661V39.5325L128.938 37.2455V33.6516V31.0379L129.592 28.0975L126.651 25.157L124.364 22.5433L121.751 21.2365L117.503 19.6029V17.6426V14.7022L114.236 10.1282L111.623 6.5343L107.375 5.88087L104.108 6.5343H94.9601L92.3464 5.88087L93.6533 4.57401V2.61372L88.0991 1.96029L86.4655 0H82.545V3.59386H78.9511L77.9709 2.61372H75.6839V4.57401L74.3771 5.88087L68.8229 6.5343L65.8825 8.8213L64.5756 12.7419L62.2886 13.3953L63.5955 17.6426H58.3681L56.7345 19.6029V25.157H54.7742L51.8338 26.7906L54.7742 32.0181L52.4872 33.3249L49.2201 37.2455L47.2598 48.3538L45.6262 57.8285L47.9132 63.3827L50.2002 69.917L51.8338 76.4513L53.4674 82.9856L60.9818 91.4802L64.5756 98.0145L69.8031 100.955V103.242L71.7634 106.182H76.0107L77.6442 110.756L75.0305 117.617V124.805L64.5756 130.686L45.2995 142.121L39.7453 148.329L35.8248 154.863L31.2508 164.991L26.6767 181.653L25.6261 197.646L21.8231 204.166L22.3663 211.058L20.7328 223.146L18.5089 227.394L16.9335 231.33L16.3902 235.677L14.0487 243.836L10.4549 248.41V256.904L8.8213 259.845L8.16787 266.379L4.24729 277.814L1.63357 285.655Z",
    fill: "url(#paint0_linear_0_78)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_78",
    x1: 62.5696,
    y1: 185.694,
    x2: 158.659,
    y2: 257.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObserverGradientShape);
export default __webpack_public_path__ + "static/media/observer-gradient-shape.1bfa63bff221e8cf14bf785ab7e7fa3d.svg";
export { ForwardRef as ReactComponent };